module.exports = __webpack_public_path__ + "static/intro_hi-c181a352712e1b063d4e16793de6c5e3.mp4";